var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.default_price && _vm.product.default_price.tax_exemption_reason)?_c('div',{staticClass:"mt-1 small text-info"},[_vm._v("\n    "+_vm._s(_vm.product.default_price.tax_exemption_reason)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }